"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOrderLine = void 0;
const _ = require("lodash");
const regions_1 = require("../regions");
const addOrderLog_1 = require("./addOrderLog");
const getOrderById_1 = require("./getOrderById");
const getOrderLineTitle_1 = require("./getOrderLineTitle");
const updateOrder_1 = require("./updateOrder");
const getOrderLineDescriptions_1 = require("./getOrderLineDescriptions");
const dayjs = require("dayjs");
const currencyFormatter_1 = require("../currencyFormatter");
const getOrderLineCurrency_1 = require("./getOrderLineCurrency");
const getOrderLineTotal_1 = require("./getOrderLineTotal");
const createOrderLine = async (obj, supabase) => {
    const { data: { user }, } = await supabase.auth.getUser();
    const order_line = _.cloneDeep(obj);
    const order = (await (0, getOrderById_1.getOrderById)(supabase, order_line.order_id));
    if (order?.country_id === null) {
        // get the region of the order_line
        const version = order_line?.versions ? order_line?.versions[0] : null;
        if (version?.region_id) {
            const region = await (0, regions_1.getRegion)(supabase, version?.region_id);
            order.country_id = region?.country_id;
            await (0, updateOrder_1.updateOrder)(supabase, order);
        }
    }
    const order_version = obj.versions ? obj.versions[0] : null;
    if (order_version)
        order_version.created_by = user?.id;
    const orderline_obj = _.cloneDeep(order_line);
    delete orderline_obj.versions;
    delete orderline_obj?.reminders;
    const { data, error } = await supabase
        .from("order_lines")
        .insert([orderline_obj]);
    const { data: version_data, error: version_error } = await supabase
        .from("order_line_versions")
        .insert([order_version]);
    if (!error && !version_error) {
        const desc = (0, getOrderLineDescriptions_1.getOrderLineDescriptions)(order_line);
        if (order_version) {
            order_line.versions?.push(order_version);
            await (0, addOrderLog_1.addOrderLog)(supabase, {
                type: obj.type,
                order_id: obj.order_id,
                detail: {
                    type: "Line Created",
                    status: order_version?.status,
                    title: `${(0, getOrderLineTitle_1.getOrderLineTitle)(order_line)} - ${dayjs(order_version?.start_date).format("DD MMM [‘]YY")}`,
                    total: (0, currencyFormatter_1.currencyFormatter)((0, getOrderLineCurrency_1.getOrderLineCurrency)(order_line) || "", (0, getOrderLineTotal_1.getOrderLineTotal)(order_line), false),
                    message: `${desc && desc.join("<br/>")}`,
                },
            });
        }
        return { data, version_data };
    }
    return error;
};
exports.createOrderLine = createOrderLine;
